import React from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

export default function DateRangeFilter(props) {
  const { startDate, setStartDate } = props.data;

  return (
    <div className="date-range-filter">
      <label>Start Date :</label>&nbsp;
      <DatePicker
        selected={startDate}
        onChange={(date) => setStartDate(date)}
        dateFormat="yyyy-MM-dd"
        placeholderText="Select a date"
      />
    </div>
  );
}
